import { render, staticRenderFns } from "./SubGroupModal.vue?vue&type=template&id=829e32b0&scoped=true"
import script from "./SubGroupModal.vue?vue&type=script&lang=js"
export * from "./SubGroupModal.vue?vue&type=script&lang=js"
import style0 from "./SubGroupModal.vue?vue&type=style&index=0&id=829e32b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829e32b0",
  null
  
)

export default component.exports